import { ssData } from "data/ss-store";
import { logout, trackEvent } from "utils";

export async function handleUnauthorized(details: { endpoint: string }) {
  trackEvent("Unauthorized Request", details);
  if (ssData.featureFlags.universalLogin) {
    await logout();
  }
}
